
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"1440","height":"182","preserveAspectRatio":"none","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"#66528F","stroke":"#000","stroke-width":"2","d":"M-2 28h1444v153H-2z"}}),_c('path',{attrs:{"fill":"#B18DF9","stroke":"#000","stroke-width":"2","d":"M-2 1h1444v153H-2z"}})])
          )
        }
      }
    